import { Link } from 'react-router-dom';
import BrandMark from './BrandMark';
import { BRAND_NAME, BRAND_TAGLINE } from '../lib/brand';

export default function MarketingFooter() {
  return (
    <footer className="border-t border-ink-100 bg-warm-50">
      <div className="container-app py-14 grid md:grid-cols-4 gap-8">
        <div className="space-y-3">
          <BrandMark tone="dark" size={26} />
          <p className="text-sm text-ink-500 max-w-xs">{BRAND_TAGLINE}</p>
        </div>
        <div>
          <div className="field-label mb-3">Learn</div>
          <ul className="space-y-2 text-sm text-ink-600">
            <li><Link to="/try" className="hover:text-ink-900">Try a challenge</Link></li>
            <li><Link to="/skill-paths" className="hover:text-ink-900">Skill paths</Link></li>
            <li><Link to="/blog" className="hover:text-ink-900">Blog</Link></li>
            <li><Link to="/pricing" className="hover:text-ink-900">Pricing</Link></li>
          </ul>
        </div>
        <div>
          <div className="field-label mb-3">Account</div>
          <ul className="space-y-2 text-sm text-ink-600">
            <li><Link to="/login?mode=signup" className="hover:text-ink-900">Create account</Link></li>
            <li><Link to="/login" className="hover:text-ink-900">Sign in</Link></li>
          </ul>
        </div>
        <div>
          <div className="field-label mb-3">Legal</div>
          <ul className="space-y-2 text-sm text-ink-600">
            <li><Link to="/privacy" className="hover:text-ink-900">Privacy</Link></li>
            <li><Link to="/terms" className="hover:text-ink-900">Terms</Link></li>
            <li><Link to="/subprocessors" className="hover:text-ink-900">Sub-processors</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-ink-100">
        <div className="container-app py-6 text-xs text-ink-500 flex flex-wrap items-center justify-between gap-4">
          <div>(c) {new Date().getFullYear()} {BRAND_NAME}. All rights reserved.</div>
          <div className="flex flex-wrap gap-4">
            <Link to="/privacy" className="hover:text-ink-900">Privacy</Link>
            <Link to="/terms" className="hover:text-ink-900">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
